export default __webpack_public_path__ + "static/media/image6.301ef492.png";